/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { Card, Form, Input, Typography } from 'antd';

import { ValidationError } from '@/components/Forms/ValidationError';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Container } from '@/primitives/Container';
import { Text } from '@/primitives/Text';

const { Title } = Typography;

export function TokenNameSection() {
  const { t } = useMimicTranslation('apiTokens');

  return (
    <Card>
      <Container gap="md">
        <Title level={4} style={{ margin: 0 }}>
          {t('tokenForm.generalInfo')}
        </Title>

        <div style={{ width: '100%' }}>
          <Form.Item
            label={<Text style={{ fontWeight: '600' }}>{t('tokenForm.nameLabel')}</Text>}
            name="name"
            rules={[
              {
                required: true,
                message: <ValidationError>{t('createTokenModal.nameRequired')}</ValidationError>,
              },
              {
                max: 30,
                message: <ValidationError>{t('createTokenModal.nameMaxLength', { maxLength: 30 })}</ValidationError>,
              },
            ]}
            extra={<span style={{ color: '#8c8c8c', fontSize: '13px' }}>{t('tokenForm.nameHelp')}</span>}
            style={{ marginBottom: 0 }}
          >
            <Input
              placeholder={t('tokenForm.namePlaceholder')}
              style={{
                borderRadius: '4px',
                fontSize: '14px',
                width: '100%',
              }}
            />
          </Form.Item>
        </div>
      </Container>
    </Card>
  );
}
